package com.arenaproplay.admin.ui.utils

/** Converts a 2-letter ISO country code to flag emoji using regional indicator chars. */
fun countryFlag(code: String): String {
    if (code.length != 2) return "🌐"
    val base = 0x1F1E6
    val a = code[0].uppercaseChar().code - 'A'.code
    val b = code[1].uppercaseChar().code - 'A'.code
    // Kotlin/JS: use surrogate pairs to encode supplementary code points
    fun codePointToString(cp: Int): String {
        val high = 0xD800 + ((cp - 0x10000) shr 10)
        val low = 0xDC00 + ((cp - 0x10000) and 0x3FF)
        return "${high.toChar()}${low.toChar()}"
    }
    return codePointToString(base + a) + codePointToString(base + b)
}

/**
 * Localized (ru) country name from a 2-letter ISO code via Intl.DisplayNames;
 * falls back to the uppercased code when the API or the code is unavailable.
 */
fun countryNameRu(iso: String): String = try {
    val dn: dynamic = js("new Intl.DisplayNames(['ru'], { type: 'region' })")
    (dn.of(iso.uppercase()) as? String) ?: iso.uppercase()
} catch (e: Throwable) {
    iso.uppercase()
}
